const DRIVER_STATUS_FILTERS = {
  RouteStarted: "RouteStarted",
  EnrouteToStop: "EnrouteToStop",
  ArrivedAtStop: "ArrivedAtStop",
  TrailerDropped: "TrailerDropped",
  TrailerHooked: "TrailerHooked",
  ArrivedAtTerminal: "ArrivedAtTerminal",
  ReturnToTerminal: "ReturnToTerminal",
  StopCompleted: "StopCompleted",
  EndOfTrip: "EndOfTrip",
  FuelBreak: "FuelBreak",
  LunchBreak: "LunchBreak",
};
const DRIVER_STATUS_FILTER_LIST = [
  { label: "Route Started", value: DRIVER_STATUS_FILTERS.RouteStarted },
  { label: "Enroute To Stop", value: DRIVER_STATUS_FILTERS.EnrouteToStop },
  { label: "Arrived At Stop", value: DRIVER_STATUS_FILTERS.ArrivedAtStop },
  { label: "Trailer Dropped", value: DRIVER_STATUS_FILTERS.TrailerDropped },
  { label: "Trailer Hooked", value: DRIVER_STATUS_FILTERS.TrailerHooked },
  { label: "Fuel Break", value: DRIVER_STATUS_FILTERS.FuelBreak },
  { label: "Lunch Break", value: DRIVER_STATUS_FILTERS.LunchBreak },
  {
    label: "Arrived At Terminal",
    value: DRIVER_STATUS_FILTERS.ArrivedAtTerminal,
  },
  {
    label: "Return To Terminal",
    value: DRIVER_STATUS_FILTERS.ReturnToTerminal,
  },
  {
    label: "Stop Completed",
    value: DRIVER_STATUS_FILTERS.StopCompleted,
  },
  {
    label: "End Of Trip",
    value: DRIVER_STATUS_FILTERS.EndOfTrip,
  },
];

const VIOLATIONS_FILTER_LIST = [
  { label: "Behind Schedule", value: "Delayed" },
  { label: "On Track", value: "On Time" },
];

const SORT_TIME_FIELDS = {
  DRIVER_CLOCKED_IN_TIME: "driverClockedInTime",
  DRIVER_CLOCKED_OUT_TIME: "driverClockedOutTime",
};
const SORT_OPTIONS_LIST = [
  { label: "Driver Name", value: "driverName" },
  { label: "Driver Status", value: "driverStatus" },
  { label: "Clock In Time", value: SORT_TIME_FIELDS.DRIVER_CLOCKED_IN_TIME },
  { label: "Clock Out Time", value: SORT_TIME_FIELDS.DRIVER_CLOCKED_OUT_TIME },
];

export {
  DRIVER_STATUS_FILTERS,
  DRIVER_STATUS_FILTER_LIST,
  VIOLATIONS_FILTER_LIST,
  SORT_OPTIONS_LIST,
  SORT_TIME_FIELDS,
};
